import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-theme-toggle',
  imports: [CommonModule],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent {
  dark = false;

  ngOnInit(): void {
    // restore preference if available
    this.dark = localStorage.getItem('theme') === 'dark-gold';
    document.body.classList.toggle('dark-gold', this.dark);
  }

  toggleTheme() {
    this.dark = !this.dark;
    document.body.classList.toggle('dark-gold', this.dark);
    localStorage.setItem('theme', this.dark ? 'dark-gold' : 'light-gold');
  }
}
